const es = {
    'scheduledcommand.table.title': 'Programación de comandos',
    'scheduledcommand.table.button.create': 'Crear tarea',
    'scheduledcommand.table.description': 'Descripción',
    'scheduledcommand.table.command': 'Comando',
    'scheduledcommand.table.arguments': 'Argumentos',
    'scheduledcommand.table.cronExpression': 'Expresión cron',
    'scheduledcommand.table.lastExecution': 'Última ejecución',
    'scheduledcommand.table.lastReturnCode': 'Último código de retorno',
    'scheduledcommand.table.lastOutput': 'Última salida',
    'scheduledcommand.table.status': 'Estado',
    'scheduledcommand.table.running': 'Ejecutando',
    'scheduledcommand.table.actions': 'Acciones',
    'scheduledcommand.table.lastOutput.show': 'Mostrar salida',
    'scheduledcommand.table.lastOutput.title': 'Salida de la última ejecución',
    'scheduledcommand.table.lastOutput.close': 'Cerrar',
    'scheduledcommand.table.enabled': 'Habilitado',
    'scheduledcommand.table.disabled': 'Deshabilitado',
    'scheduledcommand.table.notRunning': 'No ejecutando',
    'scheduledcommand.table.enable': 'Habilitar',
    'scheduledcommand.table.disable': 'Deshabilitar',
    'scheduledcommand.table.run.title': 'Ejecutar tarea',
    'scheduledcommand.table.run.phrase': '¿Estás seguro de que deseas ejecutar la tarea?',
    'scheduledcommand.table.run.cancel': 'Cancelar',
    'scheduledcommand.table.run.run': 'Confirmar',
    'scheduledcommand.table.disable.title': 'Deshabilitar tarea',
    'scheduledcommand.table.disable.phrase': '¿Estás seguro de que deseas deshabilitar la tarea?',
    'scheduledcommand.table.disable.cancel': 'Cancelar',
    'scheduledcommand.table.disable.disable': 'Confirmar',
    'scheduledcommand.table.enable.title': 'Habilitar tarea',
    'scheduledcommand.table.enable.phrase': '¿Estás seguro de que deseas habilitar la tarea?',
    'scheduledcommand.table.enable.cancel': 'Cancelar',
    'scheduledcommand.table.enable.enable': 'Confirmar',
    'scheduledcommand.table.delete.title': 'Eliminar tarea',
    'scheduledcommand.table.delete.phrase': '¿Estás seguro de que deseas eliminar la tarea?',
    'scheduledcommand.table.delete.cancel': 'Cancelar',
    'scheduledcommand.table.delete.delete': 'Confirmar',

    'scheduledcommand.form.create': 'Crear tarea',
    'scheduledcommand.form.update': 'Actualizar tarea',
    'scheduledcommand.form.cancel': 'Cancelar',
    'scheduledcommand.form.description': 'Descripción',
    'scheduledcommand.form.command': 'Comando',
    'scheduledcommand.form.arguments': 'Argumentos',
    'scheduledcommand.form.cronExpression': 'Expresión cron',
    'scheduledcommand.form.disabled': 'Deshabilitado',

};

export default es;